fx.ns("common.popups", class CoverUpdateImpossible extends shared.popups.BasePersonPopup{

    constructor(model, coverChoice)
    {
        super(model, fx.get("assets").personWorried);

        this.coverChoice = coverChoice;
        this.contentWidth = 550;
        this.contentHeight = 310;
        this.showClose = true;
    }
  

    create()
    {
        super.create();
        this.title = new fx.components.Text({text:fx.text("Ce changement de couverture n'est pas possible"), className:"title center"});

        let str = fx.text("Votre album contient $ pages", [this.data.creation.numberPages]) + ", ";
        if (this.data.creation.numberPages > this.coverChoice.max_pages)
            str += fx.text("mais avec cette couverture votre album ne peut contenir <strong>plus de $ pages</strong>.<br><br> Veuillez supprimer des pages avant de choisir cette couverture.", [this.coverChoice.max_pages]);
        else
        if (this.data.creation.numberPages < this.coverChoice.min_pages)
            str += fx.text("mais avec cette couverture votre album doit contenir <strong>au moins $ pages</strong>.<br><br> Veuillez ajouter des pages avant de choisir cette couverture.", [this.coverChoice.min_pages]);

        this.text = new fx.components.Text({text:str, className:"text center"});

        this.addChild(this.title);
        this.addChild(this.text);

        this.okButton = new fx.components.Button({label : fx.text("Ok"), type : "filled"});
        
        this.addFooterChild(this.okButton, {width : 250});
    
    }

    onReady()
    {
        super.onReady();

        this.on("click", this.close, this.okButton);
    }


});
